import { render } from "./InstagramPost.vue?vue&type=template&id=d730d59e"
import script from "./InstagramPost.vue?vue&type=script&lang=js"
export * from "./InstagramPost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__